import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledCollapse, Card, CardHeader, CardBody } from 'reactstrap';
import { TablaCabecera } from './TablaCabecera';
import { TablaComentarios } from './TablaComentarios';
import { AppContext } from './../AppContext';
//import Swal from 'sweetalert2'
//import withReactContent from 'sweetalert2-react-content'

//const MySwal = withReactContent(Swal);
//const TITLE = process.env.REACT_APP_TITLE;
const TITLE = "Reportes de Retroalimentación Estudiantil";
const APIURL = process.env.REACT_APP_API_URL;

export class Comentarios extends Component {
    static displayName = Comentarios.name;

    constructor(props) {
        super(props);
        this.state = { paralelo: null, datos: [], areas: [], frecuencias: [], alternativas: [], loading: true };
    }

    componentDidMount() {
        const currentUser = this.context.currentUser;
        const { loading } = this.state;
        document.title = TITLE + " - Comentarios por profesor";

        const params = this.props.match.params;

        if (currentUser && currentUser != undefined && loading) {
            if (Object.keys(params).length === 3) {
                const { sistema, idcurso, idpersona } = params;
                this.populateData(sistema, idcurso, idpersona);
            } else {
                const { anio, termino, codigo, paralelo, identificacion, idnivelformacion } = params;
                this.populateData2(anio, termino, codigo, paralelo, identificacion, idnivelformacion);
            }
        }
    }

    toggle(area) {
        const i = this.state.areas.indexOf(area);
        this.setState(({ areas }) => ({
            areas: [
                ...areas.slice(0, i),
                {
                    ...areas[i],
                    comparativo: !areas[i].comparativo,
                },
                ...areas.slice(i + 1)
            ]
        }));
    }

    formatter(valor) {
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: '2', maximumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }

    renderTable(paralelo, data) {
        let comentario = [];
        data.forEach(c => {
            if (c.comentario && c.comentario.length > 0) {
                comentario.push(c.comentario);
            }
        });

        let mantener = [];
        data.forEach(c => {
            if (c.mantener && c.mantener.length > 0) {
                mantener.push(c.mantener);
            }
        });

        let mejorar = [];
        data.forEach(c => {
            if (c.mejorar && c.mejorar.length > 0) {
                mejorar.push(c.mejorar);
            }
        });
        let cambiar = [];
        data.forEach(c => {
            if (c.cambiar && c.cambiar.length > 0) {
                cambiar.push(c.cambiar);
            }
        });

        return (
            <>
                <TablaCabecera paralelo={paralelo} />
                <br />
                {comentario && comentario.length > 0 && <TablaComentarios tipo={"Comentarios"} comentarios={comentario} />}
                <br />
                {mantener && mantener.length > 0 && <TablaComentarios tipo={"Debe mantener"} comentarios={mantener} />}
                <br />
                {mejorar && mejorar.length > 0 && <TablaComentarios tipo={"Debe mejorar"} comentarios={mejorar} />}
                <br />
                {cambiar && cambiar.length > 0 && <TablaComentarios tipo={"Debe cambiar"} comentarios={cambiar} />}
            </>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderTable(this.state.paralelo, this.state.comentarios);

        return (
            <>
                <div>
                    <h1 id="tabelLabel" className="text-center">Comentarios por Paralelo</h1>
                    {contents}
                </div>
            </>
        );
    }

    async populateData2(anio, termino, codigo, paralelo, identificacion, idnivelformacion) {
        const response = await fetch(`${APIURL}/api/reporte-usuario/paralelo-profesor/${anio}/${termino}/${codigo}/${paralelo}/${identificacion}/${idnivelformacion}`);
        const data = await response.json();

        const dataResponse = await fetch(`${APIURL}/api/reporte-usuario/paralelo-profesor-comentarios/${anio}/${termino}/${codigo}/${paralelo}/${identificacion}/${idnivelformacion}`);
        const dataComentarios = await dataResponse.json();

        this.setState({ paralelo: data, comentarios: dataComentarios, loading: false });
    }

    async populateData(sistema, idcurso, idpersona) {
        const response = await fetch(`${APIURL}/api/reporte-usuario/paralelo-profesor/${sistema}/${idcurso}/${idpersona}`);
        const data = await response.json();

        const dataResponse = await fetch(`${APIURL}/api/reporte-usuario/paralelo-profesor-comentarios/${sistema}/${idcurso}/${idpersona}`);
        const dataComentarios = await dataResponse.json();

        this.setState({ paralelo: data, comentarios: dataComentarios, loading: false });
    }
}
Comentarios.contextType = AppContext;